module.exports = __webpack_public_path__ + "static/media/lukasz.05d9f106.jpeg";